export { default as Center } from './Center';
export { default as Square } from './Square';
export { default as Circle } from './Circle';
export type { ICenterProps, ICircleProps, ISquareProps } from './props';
